import { createCognitoAuthorizationHeader } from "./../utils/createCognitoAuthorizationHeader";
import { addUserTokensToStorage } from "../redux/actions/actionCreators";

export default {
  returnRejectedPromiseOnError: true,
  interceptors: {
    request: [
      async ({ getState, dispatch }, request) => {
        const {
          auth: { cognitoUser },
        } = getState();

        const { headers, refreshedTokens } = await createCognitoAuthorizationHeader(
          cognitoUser,
          true,
          dispatch
        );

        if (refreshedTokens) {
          dispatch(addUserTokensToStorage(refreshedTokens));
        }

        if (headers) {
          request.headers.authorization = headers.authorization;
        }

        return request;
      },
    ],
  },
};
